<script lang="ts">
  import { page } from '$app/stores';

  import Meta from '$components/Meta.svelte';
  import Auth from '$routes/auth/account/_components/Auth.svelte';

  const paramsWithoutRedirect = new URLSearchParams($page.url.search);
  paramsWithoutRedirect.delete('redirect');
  const redirectUrl =
    ($page.url.searchParams.get('redirect') || '/account') +
    (paramsWithoutRedirect.toString() ? `?${paramsWithoutRedirect.toString()}` : '');

  const namePrefilled = $page.url.searchParams.get('name') || '';
</script>

<Meta title="Join" description="Create your account to join the best coaches and creators in the world." />

<Auth
  variant="full"
  flow="create"
  {redirectUrl}
  {namePrefilled}
  switchHref={true}
  class="bg-ondark-base xl:border-ondark-subtle mx-auto h-full max-w-[400px] xl:h-[596px] xl:max-w-[960px] xl:rounded-2xl xl:border"
/>
